<template>
  <div>
    <h-loading v-if="isRealEstateUserLoading" />
    <div v-if="realEstateUser && !isRealEstateUserLoading">
      <h6 class="text-uppercase grey--text">
        {{ $t('realEstateUsers.label.name') }}
      </h6>
      <span class="font-weight-medium">
        {{ realEstateUser.name }}
      </span>
      <h6 class="text-uppercase grey--text mt-3">
        {{ $t('realEstateUsers.label.email') }}
      </h6>
      <span class="font-weight-medium">
        {{ realEstateUser.username }}
      </span>
      <h6 class="text-uppercase grey--text mt-3">
        {{ $t('realEstateUsers.label.phone') }}
      </h6>
      <span class="font-weight-medium">
        {{ formatPhone(realEstateUser.phone) }}
      </span>

      <div v-if="realEstateUser.real_estate">
        <v-divider class="my-5" />

        <h6 class="text-uppercase grey--text">
          {{ $t('realEstateUsers.label.realEstate') }}
        </h6>
        <span class="font-weight-medium">
          {{ realEstateUser.real_estate.name }}
        </span>
        <h6 class="text-uppercase grey--text mt-3">
          {{ $t('realEstateUsers.label.branch') }}
        </h6>
        <span class="font-weight-medium">
          {{ realEstateUser.branch.name }}
        </span>
        <h6 class="text-uppercase grey--text mt-3">
          {{ $t('realEstateUsers.label.address') }}
        </h6>
        <span class="font-weight-medium">
          {{ realEstateUser.branch.address }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogPhone } from '@/util/catalog'

export default {
  name: 'RealEstateUsersDetails',
  computed: {
    ...mapGetters(['isRealEstateUserLoading', 'realEstateUser']),
  },
  methods: {
    formatPhone(phoneNumber) {
      return phoneNumber ? catalogPhone(phoneNumber) : ''
    },
  },
}
</script>
